import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { GridApi, CellEditingStoppedEvent, ValueFormatterParams, ColDef, ICellRendererParams, ValueGetterParams } from 'ag-grid-community';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { IconCellRendererComponent } from '../../icon-cell-renderer/icon-cell-renderer.component';
import { Router } from '@angular/router';
import { PCESModalComponent } from './../pces-lists-modal/pces-lists-modal.component';

@Component({
  selector: 'app-pces-details',
  templateUrl: './pces-details.component.html',
  styleUrls: ['./pces-details.component.scss']
})
export class PcesDetailsComponent implements ICellRendererAngularComp {

  public params: any;
  private gridApi!: GridApi;

  // variable to trigger when to display HTML content after API loads
  showContent: boolean = false

  // initialize UUID
  client_uuid: string = ''
  
  // initialize objects to store details of shipment details
  pces_details: any = {}
  
  editEnabled: boolean = false

  // forms for displaying details
  detailsForm: FormGroup = this.formBuilder.group({
    clientname: '',
    clientnumber: '',
    factoringfor: '',
    groupname: '',
    clientcurrency: '',
    clientbankno: '',
    clientabaroutingno: '',
    clientaccountno: '',
    clientshortname: '',
    clientaddress: '',
    client_locality: '',
    client_region: '',
    client_postal_code: '',
    client_country: '',    
  });

  agInit(params: any): void {

    // define the targeted shipment list by getting its shipment_list_uuid
    this.params = params;
    this.gridApi = params.api;
    this.client_uuid = params.data.client_uuid

    console.log(params)
    console.log(this.client_uuid)

    const pces_details_url = `/api/pces_lists/pces_client_details.php?uuid=${this.client_uuid}`;

    // GET request to the contacts API call for specific contact_UUID
    this.http.get<any>(pces_details_url).subscribe(response => {

      this.pces_details = response.details
      console.log(this.pces_details)
      
      this.checkFormReady();
    })
  }

  // check if API is finished loading -> populate all the different forms using formbuilder
  // and set show content to true at the end to render HTML
  private checkFormReady(): void {

    if (
      this.client_uuid
    ) {

      this.detailsForm = this.formBuilder.group({

        clientname:         [this.pces_details.clientname],
        clientnumber:       [this.pces_details.clientnumber],
        factoringfor:       [this.pces_details.factoringfor],
        groupname:          [this.pces_details.groupname],
        clientcurrency:     [this.pces_details.clientcurrency],
        clientbankno:       [this.pces_details.clientbankno],
        clientbranchno:     [this.pces_details.clientbranchno],
        clientabaroutingno: [this.pces_details.clientabaroutingno],
        clientaccountno:    [this.pces_details.clientaccountno],
        clientshortname:    [this.pces_details.clientshortname],
        clientaddress:      [this.pces_details.clientaddress],
        client_locality:    [this.pces_details.client_locality],
        client_region:      [this.pces_details.client_region],
        client_postal_code: [this.pces_details.client_postal_code],
        client_country:     [this.pces_details.client_country],                                
      })
      this.detailsForm.disable();
    }

    this.showContent = true;
  }
  
  refresh(params: any): boolean {
    return false;
  }
  constructor(private http: HttpClient, private formBuilder: FormBuilder, private dialog: MatDialog, private router: Router) { }

  // function to allow for cell editing in the grid, POST request is made when cell editing is finished
  onCellEditingStopped(event: CellEditingStoppedEvent) {

    const editedValue = event.value;
    const column = event.column;
    const rowNode = event.node;

    const client_uuid = rowNode.data.client_uuid

    const client_details_url = `/api/pces_lists/pces_client_details.php?table=pces_and_accounting&command=CLIENT_INFO_UPDATE`;

    const columnName = column.getColId();

    console.log('Edited Value:', editedValue);
    console.log('Row Data:', rowNode.data);
    console.log('Column Name:', columnName)

    // create POST body of cell edited of column, columnName, and value changed, editedValue
    var postData = {
      [columnName]: editedValue,
      client_uuid: client_uuid,
    }

    console.log('Post Data:', postData);
    console.log('Stringify:', JSON.stringify(postData))

    return this.http.post<any>(client_details_url, postData)
      .subscribe(response => 
      {
        console.log('Post Response: ', response)
      })
  }

  viewPcesDetails() {
    this.router.navigate(['pces_details', this.client_uuid],);
  }

  editDetails(): void {
    this.editEnabled = true
    this.detailsForm.enable();
  }

  saveClientDetails(): void {
    this.editEnabled = false

    // set the form to the default service form's current values
    const formData = this.detailsForm.value;
    formData.client_uuid = this.client_uuid;

    const pces_details_url = `/api/pces_lists/pces_client_details.php?uuid=${this.client_uuid}`;

    const client_details_url = `/api/pces_lists/pces_client_details.php?command=CLIENT_INFO_UPDATE`;
    console.log('FORM DATA:', formData)

    this.http.post<any>(client_details_url, formData)
      .subscribe(response => {
        console.log('Post Response: ', response)

        this.detailsForm.reset()
        // GET request to retrieve the updated list of default services
        this.http.get<any>(pces_details_url).subscribe(response => {

          this.pces_details = response.details
          console.log(this.pces_details)
          
          this.checkFormReady();
          this.router.navigate(['/pces_client_lists']);          
        })
      })
  }

  deleteClient() {
    const dialogConfig = new MatDialogConfig();
    const client_uuid = this.client_uuid;
    const clientname  = this.pces_details.clientname;

    dialogConfig.width = '350px'; // You can use pixels or other units
    dialogConfig.height = '250px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Client Information',
        modalMessage: {uuid: client_uuid, client_name: clientname},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }
}
